import { toast } from 'sonner';
import { API_URL } from '../components/booking/bookingUtils';

const saveBlob = async (response) => {
  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = match ? match[1] : 'booking-form.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const downloadBookingPdf = async (bookingId) => {
  try {
    const response = await fetch(`${API_URL}/api/booking-forms/bookings/${bookingId}/pdf-file`, { credentials: 'include' });
    if (!response.ok) throw new Error((await response.json().catch(() => ({}))).detail || 'Failed to generate PDF');
    await saveBlob(response);
  } catch (error) {
    toast.error(error.message);
  }
};

export const downloadPublicBookingPdf = async (token) => {
  try {
    const response = await fetch(`${API_URL}/api/public/bookings/${token}/pdf`);
    if (!response.ok) throw new Error((await response.json().catch(() => ({}))).detail || 'Failed to generate PDF');
    await saveBlob(response);
  } catch (error) {
    toast.error(error.message);
  }
};
